import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { ProjectSearchPageContext, ProjectSearchPageInitialState } from ".";

export const ProjectSearchPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(ProjectSearchPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ProjectSearchPageContext.Provider value={context}>
      {children}
    </ProjectSearchPageContext.Provider>
  );
};
